import {defineAsyncComponent} from 'vue'
const KeywordsRouter = [
  {
    path: 'apply',
    name: 'KeywordApply',
    component: () => import('@/views/Keywords/KeywordApply/Index.vue'),
  },
]
export {KeywordsRouter}
